import { useEffect, useRef, useState } from "react";
import { WsMessageDto } from "../types/Types";

export function useWebSocket(url: string) {
  const wsRef = useRef<WebSocket | null>(null);
  const [messages, setMessages] = useState<WsMessageDto[]>([]);

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_API_WS_URL! + url);
    wsRef.current = ws;

    ws.onmessage = e => { 
      const msg = JSON.parse(e.data);
      setMessages(prev => [...prev,msg]);
    };

    return () => ws.close();
  }, [url]);

  const send = (msg: string) => {
    wsRef.current?.send(msg);
  };

  return { messages, send };
}